/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Discard_MessageInputs */

const cs_form_discard_message = /** @type {(inputs: Form_Discard_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opravdu zahodit neuložené změny?`)
};

const en_form_discard_message = /** @type {(inputs: Form_Discard_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Discard unsaved changes?`)
};

/**
* | output |
* | --- |
* | "Discard unsaved changes?" |
*
* @param {Form_Discard_MessageInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_discard_message = /** @type {((inputs?: Form_Discard_MessageInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Discard_MessageInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_discard_message(inputs)
	return cs_form_discard_message(inputs)
});